
'use strict';
import React, { Component } from 'react';
import {View, Text, TouchableOpacity, Keyboard, ScrollView, ImageBackground} from 'react-native';
import styles from '../style';
import { observer, inject } from 'mobx-react';
import Icon from '../../../../../components/Icon'
import {getScreenSize} from "../../../../../common/utils";

const PADDING = 34;
const INTERVAL = 10;

@inject(stores => {
    const {searchDataStore} = stores,
        {filterData, handleSelectMonth, selectedMonthsMap, logData} = searchDataStore;

    return {
        logData,
        filterData,
        handleSelectMonth,
        selectedMonthsMap
    };
})

@observer
class MonthRange extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let {groupedMonths} = this.props;

        let {lineNum} = this.props.filterData;
        if (!groupedMonths) {
            return <View/>
        }

        return (
            <View style={styles.searchFilterBlock}>
                <Text style={styles.searchFilterBlockTitle}>出行时间</Text>
                <View style={styles.searchFilterBlockContainer}>
                    {groupedMonths.map((months, i) => {
                        return <View style={styles.searchMonthBlock} key={i}>
                            {months.map((month, rowIdx) => {
                                let maxWidth = (getScreenSize().width - PADDING - (lineNum - 1) * INTERVAL) / 4;

                                if (month.text === '自定义') {
                                    return <View key={month.text}/>
                                }
                                let subText = month.subText;
                                let bgUrl = month.bgUrl;
                                let active = this.props.selectedMonthsMap[month.text];
                                let Container = bgUrl && !active ? ImageBackground : View;
                                return <TouchableOpacity
                                    key={month.text}
                                    onPress={() => {
                                        GodEye.log({
                                            r: 'month_range_click',
                                            month: month.text,
                                            ...this.props.logData
                                        });
                                        this.props.handleSelectMonth(month)
                                    }}
                                    style={[
                                        styles.searchMonth,
                                        active ? styles.searchActiveItem : {},
                                        rowIdx === lineNum - 1 ? {marginRight: 0} : {},
                                        {maxWidth: maxWidth}
                                    ]}
                                >
                                    <Container source={bgUrl} style={[
                                        styles.searchBaseItem,
                                        subText ? styles.sepcText : {}, styles.searchItem,
                                        active ? styles.searchActiveItem : {}
                                    ]}>
                                        <Text style={[styles.searchText, active ? styles.searchActiveText : {}]}>
                                            {month.text}
                                        </Text>
                                        <Text style={[styles.searchSubText, active ? styles.searchActiveText : {}]}>
                                            {month.subText}
                                        </Text>
                                        {active ? <View style={styles.selected}>
                                            <Icon
                                                name="check"
                                                size={15}
                                                color={'#fff'}
                                                style={styles.checkIcon}
                                                needScale={true}
                                            />
                                        </View> : null}
                                    </Container>
                                </TouchableOpacity>
                            })}
                        </View>
                    })}

                </View>
            </View>
        )
    }
}

export default MonthRange;
